module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vfcleg5-5b4e66c7dbccf5b9ae63d08caada4c1b.jpg";